export const ICONS = {

  SUCCESS: 'icon-[carbon--checkmark-filled]',
  ERROR: 'icon-[carbon--close-filled]',
  WARNING: 'icon-[carbon--warning-filled]',
  INFO: 'icon-[carbon--information-filled]',
  PENDING: 'icon-[carbon--time]',
  LOADING: 'icon-[carbon--circle-dash]',

  CHECKMARK_OUTLINE: 'icon-[carbon--checkmark-outline]',
  WARNING_ALT: 'icon-[carbon--warning-alt]',
  SUBTRACT: 'icon-[carbon--subtract]',
  HOURGLASS: 'icon-[carbon--hourglass]',

  UPGRADE: 'icon-[carbon--upgrade]',
  DOWNGRADE: 'icon-[carbon--arrow-down-right]',
  RESTART: 'icon-[carbon--restart]',
  CLOSE: 'icon-[carbon--close-outline]',
  SECURITY: 'icon-[carbon--security]',
  DOCUMENT_IMPORT: 'icon-[carbon--document-import]',
  DEPOSIT: 'icon-[carbon--money]',
  WITHDRAW: 'icon-[carbon--send]',
} as const

export const PROGRESS_THRESHOLDS = {
  LOW: 50,
  MEDIUM: 75,
  HIGH: 80,
  COMPLETE: 100,
} as const

export const PREFLIGHT_STATUS = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  PENDING: 'pending',
} as const

export const DISTRIBUTION_BADGES = {
  DRY_RUN: {
    text: 'DRY RUN',
    bgClass: 'bg-warn-soft',
    textClass: 'text-warn',
  },
  EXECUTED: {
    text: 'EXECUTED',
    bgClass: 'bg-accent-soft',
    textClass: 'text-accent',
  },
} as const

export const PREFLIGHT_ICON_MAP = {
  success: ICONS.SUCCESS,
  error: ICONS.ERROR,
  warning: ICONS.WARNING,
  pending: ICONS.LOADING,
} as const

export const PREFLIGHT_COLOR_MAP = {
  success: 'text-accent',
  error: 'text-danger',
  warning: 'text-warn',
  pending: 'text-ink-faint',
} as const

export const STATUS_LABELS = {
  ACTIVE: 'Active',
  ONBOARDING: 'Onboarding',
  INACTIVE: 'Inactive',
  SUSPENDED: 'Suspended',
  ACTION_REQUIRED: 'Action Required',
  VERIFIED: 'Verified',
  PENDING_REVIEW: 'Pending Review',
  REJECTED: 'Rejected',
  UPLOAD_REQUIRED: 'Upload Required',
  NOT_CONNECTED: 'Not Connected',
  FUNDING_REQUIRED: 'Funding Required',
  READY_TO_DEPOSIT: 'Ready to Deposit',
  REQUIREMENT_MET: 'Requirement Met',
  EXCESS_BALANCE: 'Excess Balance',
} as const

export const MEMBERSHIP_MESSAGES = {
  DASHBOARD_TITLE: 'Membership Dashboard',
  DASHBOARD_SUBTITLE_ACTIVE: 'Manage your membership and access your benefits',
  DASHBOARD_SUBTITLE_DEACTIVATED: 'Your membership is deactivated - resolve the issues below to reactivate',
  APPLICATION_TITLE: 'Membership Application',
  APPLICATION_SUBTITLE: 'Join the Avow community and get access to exclusive benefits',
  DEFAULT_TITLE: 'Membership',
  DEFAULT_SUBTITLE: 'Check your status and manage your benefits',
} as const

export const ACTION_LABELS = {
  QUICK_ACTIONS: 'Quick Actions',
  REACTIVATE: 'Reactivate',
  REACTIVATE_MEMBERSHIP: 'Reactivate Membership',
  UPDATE_INSURANCE: 'Update Insurance',
  UPGRADE_TIER: 'Upgrade Tier',
  DOWNGRADE_TIER: 'Downgrade Tier',
  END_MEMBERSHIP: 'End Membership',
  DEPOSIT_FUNDS: 'Deposit Funds',
  WITHDRAW_FUNDS: 'Withdraw Funds',
} as const

export const VALIDATION_MESSAGES = {
  ACTIVE_MEMBERSHIP_REQUIRED: 'Active membership required',
  NO_UPGRADE_TIERS: 'No upgrade tiers available',
  NO_DOWNGRADE_TIERS: 'No downgrade tiers available',
  MEMBERSHIP_RECORD_REQUIRED: 'Membership record required',
  NO_MEMBERSHIP_TO_END: 'No membership to end',
  ALREADY_ACTIVE: 'Already have active membership',
  UNKNOWN_ACTION: 'Unknown action',
  DOCUMENT_REJECTED: 'Document was rejected',
} as const
